import React from "react";
import ManagementCommitee from "./assests/Management.png";
// import ManagementDescription from './assests/ManagementDescription.png'
import "../style/management.css";
import table1 from "./assests/ManagementTable1.png";
import table2 from "./assests/ManagementTable2.png";
import img1 from "./assests/Group 72.png";
import img2 from "./assests/amardeep-kohli 1.png";
const Management = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <img src={ManagementCommitee} />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-6">
          <p className="manage-heading">S.AMARDEEP SINGH KOHLI</p>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <p className="manage-heading2">CHAIRMAN</p>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <p className="manage-heading3">
            "EDUCATION IS THE MOST POWERFUL WEAPON WHICH YOU CAN USE TO CHANGE
            THE WORLD"{" "}
          </p>
        </div>
      </div>
      <div className="row mt-14">
        <div className="col-lg-4 col-md-4 col-sm-12 ">
          <img src={img1} className="" />
        </div>
        <div className="col-lg-1 col-md-1 col-sm-12"></div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <p className="kohli-descripton">
            It is a great honor and privilege that i am associated with this
            august institution that imparts an educative and formative platform
            to the future generation of young and upcoping citizens of our
            metropolis. <br />
            It is our earnest endeavor hat each budding inmate passing through
            our portals is sincerely and diligently nurtured to face the future
            with integrity, valor and pride. <br />
            All of us at the GURU HARKRISHAN HIGH SCHOOL & JUNIOR COLLEGE,
            uphold the high ideals set by our predecessors,to ensure that the
            children we foster, become role models and achieve exemplary heights
            in various fieds, during the future course of their lives. <br />
            I am thankful to WAHE GURUJI and the Member of our institution's
            Society, to have reposed their faith in my team to nurture and help
            mould the future of our generation. It is our assurance that we will
            strive to take this institution to soaring heights that each Alumni
            feels proud to have passed out from these hallowed gates. <br />
            We seek Drivine Blessings and all your Good Wishes to assist. us in
            this worthy journey.
          </p>
        </div>
        <div className="col-lg-1 col-md-1 col-sm-12"></div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-6">
          <p className="manage-heading">S.AMANPREET SINGH CHADHA</p>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <p className="manage-heading2">SECRETARY</p>
        </div>
      </div>{" "}
      <br /> <br />
      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-12">
          <img src={img2} className="kohli-img" /> <br />
        </div>
        <div className="col-lg-1 col-md-1 col-sm-12"></div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <p className="kohli-descripton">
            I have become an active member of this institution only after the
            demise of my father, S. Kuldip Singh Chadha, who was a patron and a
            very active Chairman of the Governing Council. I distinctly recall
            that inspite of his age and some times bad health, he would get
            charged and fully involved with this institution's development and
            infrastructure. His passion and zeal to build a state of the art
            institution really motivated me to come into the working committee
            of this continuously progressing institution. <br />
            I must admit that whenever I come to this institution for meetings
            and other project related works, I am motivated to give my best to
            the institution. <br />
            To see the pain staking efforts of the Director, the Principal and
            the entire staff on a day to day basis to bring about a palpable
            change in the lives of the students is a very satisfying experience.
            The changes that have occurred in the last few years in this
            institution need to be applauded. <br />I congratulate each one of
            the members who is associated with this instituation and at my end i
            am commited with this institustion and at my end I am committed to
            give full support to this institustion in whatever way it is
            possible for me.
          </p>
        </div>
        <div className="col-lg-1 col-md-1 col-sm-12"></div>
      </div>{" "}
      <br />
      <img src={table1} class="responsiveImage " /> <br />
      <img src={table2} class="responsiveImage " />
    </div>
  );
};

export default Management;
